import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import {
  Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle,
} from "../ui/dialog";

const API_URL = process.env.REACT_APP_BACKEND_URL;

/** Dialog di creazione/modifica per un modulo da firmare (titolo + descrizione). */
export default function ModuloFormDialog({ open, onOpenChange, modulo, token, onSaved }) {
  const [titolo, setTitolo] = useState("");
  const [descrizione, setDescrizione] = useState("");
  const [saving, setSaving] = useState(false);

  const isEdit = Boolean(modulo);

  useEffect(() => {
    if (open) {
      setTitolo(modulo?.titolo || "");
      setDescrizione(modulo?.descrizione || "");
    }
  }, [open, modulo]);

  const save = async () => {
    if (titolo.trim().length < 2) { toast.error("Il nome deve avere almeno 2 caratteri"); return; }
    setSaving(true);
    try {
      if (isEdit) {
        await axios.put(
          `${API_URL}/api/moduli-firma/${modulo.id}`,
          { titolo: titolo.trim(), descrizione: descrizione.trim() },
          { headers: { Authorization: `Bearer ${token}` } },
        );
        toast.success("Modulo aggiornato");
      } else {
        await axios.post(
          `${API_URL}/api/moduli-firma`,
          { titolo: titolo.trim(), descrizione: descrizione.trim() },
          { headers: { Authorization: `Bearer ${token}` } },
        );
        toast.success("Modulo creato");
      }
      onOpenChange(false);
      onSaved?.();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore salvataggio modulo");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{isEdit ? "Modifica modulo" : "Nuovo modulo"}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label htmlFor="modulo-titolo">Nome del modulo</Label>
            <Input
              id="modulo-titolo"
              value={titolo}
              onChange={(e) => setTitolo(e.target.value)}
              placeholder="Es. Consenso attività ricreative"
              className="mt-1"
              autoFocus
            />
          </div>
          <div>
            <Label htmlFor="modulo-descrizione">Descrizione</Label>
            <Textarea
              id="modulo-descrizione"
              value={descrizione}
              onChange={(e) => setDescrizione(e.target.value)}
              placeholder="Breve descrizione visibile sulla card"
              rows={3}
              className="mt-1"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Annulla</Button>
          <Button className="bg-purple-600 hover:bg-purple-700" onClick={save} disabled={saving}>
            {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            {isEdit ? "Salva modifiche" : "Crea modulo"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
